import { SellInvoice } from '../types/sale';
import axios from './Instance/axiosInstance';

const API = '/sells';

export async function fetchSales(): Promise<SellInvoice[]> {
    const { data } = await axios.get(API);
    return data;
}
export async function addSale(sale: Partial<SellInvoice>): Promise<SellInvoice> {
    const { data } = await axios.post(API, sale);
    return data;
}
export async function updateSale(id: string, sale: Partial<SellInvoice>): Promise<SellInvoice> {
    const { data } = await axios.put(`${API}/${id}`, sale);
    return data;
}
export async function deleteSale(id: string): Promise<void> {
    await axios.delete(`${API}/${id}`);
}

export async function fetchSale(id: string): Promise<SellInvoice> {
    const { data } = await axios.get(`${API}/${id}`);
    return data
}